import { useState, useEffect, useRef } from "react";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [showBack, setShowBack] = useState(false);
  const timerRef = useRef(null);
  useEffect(() => {
    const goOffline = () => { setOffline(true); setShowBack(false); };
    const goOnline  = () => {
      setShowBack(true);
      setOffline(false);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setShowBack(false), 3000);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online',  goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online',  goOnline);
      clearTimeout(timerRef.current);
    };
  }, []);
  if (!offline && !showBack) return null;
  const bg    = offline ? '#b91c1c' : '#15803d';
  const label = offline ? '⚡ لا يوجد اتصال بالإنترنت — وضع أوف لاين' : '✓ عاد الاتصال بالإنترنت';
  return (
    <div style={{
      position:'fixed', top:0, left:0, right:0, zIndex:99999,
      background:bg, color:'#fff', textAlign:'center',
      padding:'8px 16px', fontSize:'13px', fontWeight:700,
      fontFamily:'Cairo,sans-serif', direction:'rtl',
      boxShadow:'0 2px 8px rgba(0,0,0,0.25)',
      transition:'background 0.3s',
    }}>
      {label}
    </div>
  );
}
